(() => {
  const INTERNAL = 'X-Single-Item';
  let clearing = false;

  async function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', [INTERNAL]: '1' }
    });
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url;
    const method = (init.method || 'GET').toUpperCase();

    const isAdd =
      method === 'POST' &&
      url &&
      url.includes('/cart/add.js');

    const isInternal =
      init.headers &&
      ((init.headers instanceof Headers && init.headers.get(INTERNAL)) ||
       init.headers[INTERNAL]);

    if (!isAdd || isInternal || clearing) {
      return originalFetch(input, init);
    }

    try {
      clearing = true;
      await clearCart();
    } catch (e) {
      console.warn('[single-item-cart] failed to clear cart, allowing add');
    } finally {
      clearing = false;
    }

    return originalFetch(input, init);
  };

  console.log('[single-item-cart] active');
})();
